"use client";

import { Badge, Popover, PopoverContent, PopoverTrigger } from "@oreme/ui";
import { useLocale } from "next-intl";
import React, { type HTMLAttributes, type ReactElement } from "react";
import type { Tag } from "@/types";

interface TagListItemProps extends HTMLAttributes<HTMLDivElement> {
  tag: Tag;
}

function TagListItem({ tag }: Readonly<TagListItemProps>): ReactElement {
  const locale = useLocale();

  if (tag.description[locale]) {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <Badge className="transition hover:cursor-help hover:bg-primary/80">
            {tag.name[locale]}
          </Badge>
        </PopoverTrigger>
        <PopoverContent className="text-xs leading-tight">
          {tag.description[locale]}
        </PopoverContent>
      </Popover>
    );
  }

  return <Badge>{tag.name[locale]}</Badge>;
}

export { TagListItem, type TagListItemProps };
